module.exports = __webpack_public_path__ + "img/ari.7f2be36f.jpg";